/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAssetsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListAssetsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListAssetsSecurity = {
  option1?: ListAssetsSecurityOption1 | undefined;
  option2?: ListAssetsSecurityOption2 | undefined;
};

export type ListAssetsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type ListAssetsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListAssetsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListAssetsSecurityOption1$Outbound,
  ListAssetsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listAssetsSecurityOption1ToJSON(
  listAssetsSecurityOption1: ListAssetsSecurityOption1,
): string {
  return JSON.stringify(
    ListAssetsSecurityOption1$outboundSchema.parse(listAssetsSecurityOption1),
  );
}

/** @internal */
export type ListAssetsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListAssetsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListAssetsSecurityOption2$Outbound,
  ListAssetsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAssetsSecurityOption2ToJSON(
  listAssetsSecurityOption2: ListAssetsSecurityOption2,
): string {
  return JSON.stringify(
    ListAssetsSecurityOption2$outboundSchema.parse(listAssetsSecurityOption2),
  );
}

/** @internal */
export type ListAssetsSecurity$Outbound = {
  Option1?: ListAssetsSecurityOption1$Outbound | undefined;
  Option2?: ListAssetsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListAssetsSecurity$outboundSchema: z.ZodMiniType<
  ListAssetsSecurity$Outbound,
  ListAssetsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(z.lazy(() => ListAssetsSecurityOption1$outboundSchema)),
    option2: z.optional(z.lazy(() => ListAssetsSecurityOption2$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listAssetsSecurityToJSON(
  listAssetsSecurity: ListAssetsSecurity,
): string {
  return JSON.stringify(
    ListAssetsSecurity$outboundSchema.parse(listAssetsSecurity),
  );
}

/** @internal */
export type ListAssetsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const ListAssetsRequest$outboundSchema: z.ZodMiniType<
  ListAssetsRequest$Outbound,
  ListAssetsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    gramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      gramKey: "Gram-Key",
    });
  }),
);

export function listAssetsRequestToJSON(
  listAssetsRequest: ListAssetsRequest,
): string {
  return JSON.stringify(
    ListAssetsRequest$outboundSchema.parse(listAssetsRequest),
  );
}
